import { AppState } from "@/store/app.state";

export const selectGrowls = (state: AppState) => state.growls.growls
